import React from 'react'
import { Icon, Form, Grid } from 'semantic-ui-react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Title } from '../components'
import { loadLocations, clearLocations, getLocationsCSV } from '../../common/locations/actions'
import { checkFile, clearDownload } from '../../common/downloads/actions'
import { lists } from '../../common/lib/redux-lists'
import {
  TextFilter,
  
} from '../components/filters'

import { LocationsTable } from '../tables'

const { Row, Column } = Grid

class LocationsPage extends React.Component {
  constructor(props) {
    super(props)
    this.getCSV = this.getCSV.bind(this)
    this.checkCSV = this.checkCSV.bind(this)
  }
  componentWillReceiveProps(props) {
    const oldLocation = this.props.downloadLocation
    const oldPath = this.props.downloadPath
    const newLocation = props.downloadLocation
    const newPath = props.downloadPath

    if (oldLocation !== newLocation && newLocation !== '') {
      props.checkFile(newLocation)
      this.checkCSVInterval = window.setInterval(this.checkCSV, 500)
    } else if (oldPath !== newPath && newPath !== '') {
      window.clearInterval(this.checkCSVInterval)
    }
  }
  componentWillUnmount() {
    const { waitingForDownload, clearDownload, clearLocations, list } = this.props
    clearLocations()
    if (waitingForDownload) clearDownload()
    if (this.checkCSVInterval) window.clearInterval(this.checkCSVInterval)
  }
  getCSV() {
    const { list, getLocationsCSV } = this.props
    const query = list.$query()
    getLocationsCSV(query)
  }
  checkCSV() {
    const { checkFile, downloadLocation } = this.props
    checkFile(downloadLocation)
  }
  render() {
    const {
      locations, meta, list, viewer, waitingForDownload, downloadPath, clearDownload,
    } = this.props
    return (
      <div>
        <Title message="Lokace" />
        <aside className="breadcrumbs">
          <span>Lokace</span>

          <div className="options">
            <Link to="/locations/new"><button><Icon name="add" /> Nová lokace</button></Link>
          </div>
        </aside>
        <main className="content">
          <Form className="filters" size="big">
            <Grid>
              <Row>
                <Column>
                  <strong>Název:</strong>
                  <TextFilter {...list.filters['nameSort.likeCollateStart']} />
                </Column>
              </Row>
            </Grid>
          </Form>
          <LocationsTable
            locations={locations}
            meta={meta}
            list={list}
            getCSV={['ADMIN','SUPERVISOR'].indexOf(viewer.role) !== -1 && this.getCSV}
            waitingForDownload={waitingForDownload}
            csv={downloadPath}
            clearDownload={clearDownload}
          />
        </main>
      </div>
    )
  }
}

LocationsPage.defaultProps = {
  waitingForDownload: false,
  downloadPath: '',
  downloadLocation: '',
}

LocationsPage.propTypes = {
  locations: React.PropTypes.object.isRequired,
  meta: React.PropTypes.object.isRequired,
  loadLocations: React.PropTypes.func.isRequired,
  clearLocations: React.PropTypes.func.isRequired,
  list: React.PropTypes.object.isRequired,
  viewer: React.PropTypes.object.isRequired,
  waitingForDownload: React.PropTypes.bool,
  downloadPath: React.PropTypes.string,
  downloadLocation: React.PropTypes.string,
  getLocationsCSV: React.PropTypes.func.isRequired,
  checkFile: React.PropTypes.func.isRequired,
  clearDownload: React.PropTypes.func.isRequired,
}

LocationsPage = lists(LocationsPage, {
  path: 'LocationsPage',
  filters: ['nameSort.likeCollateStart'],
  headings: ['nameSort'],
  debounceTime: 50,
  loadDataAction: (props) => (props.loadLocations),
  getInitialState: () => ({
    sort: 'nameSort',
  }),
})

export default connect((state) => ({
  locations: state.locations.all,
  meta: state.locations.meta,
  viewer: state.users.viewer,
  waitingForDownload: state.downloads.downloading,
  downloadPath: state.downloads.path,
  downloadLocation: state.downloads.location,
}), { loadLocations, clearLocations, getLocationsCSV, checkFile, clearDownload })(LocationsPage)



// WEBPACK FOOTER //
// ./src/browser/pages/Locations.js